"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trainings = exports.populateExerciseGroupMap = exports.prepareExerciseGroupMap = exports.getAvailableExercisesGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hooks_1 = require("../../shared/hooks");
const styled_components_1 = __importDefault(require("styled-components"));
const ExerciseCardMobile_1 = require("./ExerciseCardMobile");
const ExerciseDayCard_1 = require("./ExerciseDayCard");
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const with_collapse_1 = require("../../molecules/with-collapse");
const NO_GROUP = "NO_GROUP";
const getAvailableExercisesGroup = (data) => Array.from(new Set(data.map((data) => data.exerciseData.group || NO_GROUP)));
exports.getAvailableExercisesGroup = getAvailableExercisesGroup;
const prepareExerciseGroupMap = (sets) => {
    const map = new Map();
    sets.forEach((set) => map.set(set, []));
    return map;
};
exports.prepareExerciseGroupMap = prepareExerciseGroupMap;
const populateExerciseGroupMap = (map, data) => {
    const mapCopy = new Map(map);
    data.forEach((item) => mapCopy.set(item.exerciseData.group || NO_GROUP, [
        ...mapCopy.get(item.exerciseData.group || NO_GROUP),
        item
    ]));
    return mapCopy;
};
exports.populateExerciseGroupMap = populateExerciseGroupMap;
const ExerciseGroupHeader = ({ group }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(GroupHeader, { children: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: `${t("memberTraining.set")} ${group}` }, void 0) }, void 0));
};
const GroupHeader = styled_components_1.default.div `
  h4 {
    font-weight: 600;
  }
`;
const renderExercise = (isMobile) => (item, index) => {
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [isMobile && ((0, jsx_runtime_1.jsx)(ExerciseCardMobile_1.ExerciseCardMobile, { exerciseData: {
                    // index,
                    ...item.exerciseData
                }, img: item.img, translations: item.translations }, item.translations.exerciseName + index)), !isMobile && ((0, jsx_runtime_1.jsx)(ExerciseDayCard_1.ExerciseDayCard, { exerciseData: {
                    // index,
                    ...item.exerciseData
                }, img: item.img, translations: item.translations, shouldBeVisibleOnStart: true }, item.translations.exerciseName + index))] }, item.translations.exerciseName + index));
};
const Trainings = ({ trainingItemsData }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    const exerciseGroupMap = (0, exports.prepareExerciseGroupMap)((0, exports.getAvailableExercisesGroup)(trainingItemsData));
    const groupMap = (0, exports.populateExerciseGroupMap)(exerciseGroupMap, trainingItemsData);
    return ((0, jsx_runtime_1.jsx)(TrainingContainer, { children: Array.from(groupMap.keys()).map((key) => {
            var _a;
            const exercises = (_a = groupMap.get(key)) === null || _a === void 0 ? void 0 : _a.map(renderExercise(isMobile));
            if (key === NO_GROUP) {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: exercises }, void 0);
            }
            return ((0, jsx_runtime_1.jsx)(with_collapse_1.WithCollapse, { header: (0, jsx_runtime_1.jsx)(ExerciseGroupHeader, { group: key }, void 0), body: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: exercises }, void 0) }, key));
        }) }, void 0));
};
exports.Trainings = Trainings;
const TrainingContainer = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.spacings.m};

  & > div:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }

  & > div > div:last-of-type > div:not(:last-of-type) {
    border-bottom: none;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div > div:last-of-type {
      padding: 0;

      & > div {
        border-bottom: none;
      }

      & > div:first-of-type {
        border-top: none;
      }
    }
  }
`;
//# sourceMappingURL=Trainings.js.map